<div>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<div *ngIf="hasData">
			<div *ngIf="!isR10Config" class="list">
				<div class="donutTable">
					<div class="table">
						<div
							*ngFor="
								let featuredNetwork of featuredNetworks
									| paginate: { id: 'featured_networks_pagination', itemsPerPage: 10, currentPage: p2 };
								index as i;
								let l = count
							"
							[class]="sectionclass"
						>
							<app-ctv-network-donut
								[events]="true"
								[innerSize]="'95%'"
								[noDataColor]="'#d8d8d8'"
								[completionPercentage]="featuredNetwork.completionRate"
								[networkUrl]="featuredNetwork.logoPath"
								[smallInnerSize]="true"
							></app-ctv-network-donut>
							<div class="description">
								<p class="networkName">{{ featuredNetwork.networkName }}</p>
								<p class="completionRate">
									{{
										featuredNetwork.completionRate >= 100 ? 100 : (featuredNetwork.completionRate | number: '1.2-2')
									}}%
								</p>
								<p class="completionRatelabel">completion rate</p>
							</div>
						</div>
						<div style="clear: both"></div>
					</div>
				</div>
				<pagination-template
					id="featured_networks_pagination"
					#p="paginationApi"
					(pageChange)="p2 = $event"
					class="ctv_featured_networks"
					*ngIf="featuredNetworks.length > 10"
				>
					<ul class="pager">
						<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
							<a (click)="p.setCurrent(1)">
								<span>First</span>
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
							<a (click)="p.setCurrent(p.getLastPage())">
								<span>Last</span>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
			<div *ngIf="isR10Config" class="isR10Config">
				<div class="donutTable">
					<div class="table">
						<div
							*ngFor="
								let featuredNetwork of featuredNetworks
									| paginate: { id: 'featured_networks_pagination', itemsPerPage: 10, currentPage: p2 };
								index as i;
								let l = count
							"
							[class]="sectionclass"
						>
							<div class="network-image">
								<img src="{{ featuredNetwork.logoPath }}" />
							</div>
							<div class="description">
								<p class="networkName">{{ featuredNetwork.networkName }}</p>
								<div class="progressBar">
									<div class="coloredBar" [ngStyle]="{ width: featuredNetwork.completionRate + '%' }"></div>
								</div>
								<p class="completionRate">
									{{
										featuredNetwork.completionRate >= 100 ? 100 : (featuredNetwork.completionRate | number: '1.2-2')
									}}%
								</p>
								<p class="completionRatelabel">Completion Rate</p>
							</div>
						</div>
					</div>
				</div>
				<pagination-template
					id="featured_networks_pagination"
					#p="paginationApi"
					(pageChange)="p2 = $event"
					class="ctv_featured_networks"
					*ngIf="featuredNetworks.length > 10"
				>
					<ul class="pager">
						<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
							<a (click)="p.setCurrent(1)">
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
										<g fill="none" fill-rule="evenodd">
											<g>
												<g>
													<g>
														<path
															d="M5.657.343L7.07 1.757 2.83 6l4.242 4.244-1.414 1.414L0 6 5.657.343zm5 0l1.414 1.414L7.83 6l4.242 4.244-1.414 1.414L5 6 10.657.343z"
															transform="translate(-1050 -663) translate(1050 658) translate(0 5)"
														/>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</span>
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
							<a (click)="p.setCurrent(p.getLastPage())">
								<span>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
										<g fill="none" fill-rule="evenodd">
											<g>
												<g>
													<g>
														<path
															d="M1.417.343L7.074 6l-5.657 5.657-1.414-1.414L4.245 6 .003 1.757 1.417.343zm5 0L12.074 6l-5.657 5.657-1.414-1.414L9.245 6 5.003 1.757 6.417.343z"
															transform="translate(-1258 -663) translate(1050 658) translate(208 5)"
														/>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</span>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
		</div>
		<div class="no-data-container r10-no_data" *ngIf="!hasData">
			<div class="no-data-feature-network">
				<div class="no-data-text">No Data Available</div>
			</div>
		</div>
	</div>
	<div class="clear"></div>
</div>
